import { useEffect, useState } from 'react';
import { Calendar } from '../components/calendar';
import { ReactComponent as AgendaItemSvg } from '../images/agenda-item.svg';
import { ReactComponent as AddSvg } from '../images/add.svg';
import './agenda.css';
import { compareDates, get, post } from './utils/utils';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/context';

export interface AgendaItem {
  id?: string;
  startDate?: Date;
  endDate?: Date;
  startTime?: string;
  endTime?: string;
  content: string;
}

export function Agenda() {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [agendaItems, setAgendaItems] = useState<AgendaItem[]>([]);
  const [time, setTime] = useState<string | undefined>(undefined);
  const [content, setContent] = useState<string>('');
  let navigate = useNavigate();
  const { user } = useAuth();
  const [refetch, setRefetch] = useState<boolean>(false);

  useEffect(() => {
    get({
      url: 'agendaItems.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        const items: AgendaItem[] = data.map((item: any) => {
          const startDate = new Date(item.startDate);
          const offsetStartDate = new Date(
            startDate.getTime() +
              Math.abs(startDate.getTimezoneOffset() * 60000)
          );
          let offsetEndDate = undefined;
          if (item.endDate) {
            const endDate = new Date(item.endDate);
            offsetEndDate = new Date(
              endDate.getTime() +
                Math.abs(startDate.getTimezoneOffset() * 60000)
            );
          }
          return {
            id: item.id,
            startTime: item.startTime,
            content: item.content,
            startDate: offsetStartDate,
            endDate: offsetEndDate,
            endTime: item.endTime
          };
        });
        setAgendaItems(items);
        setRefetch(false);
      });
  }, []);

  useEffect(() => {
    if (refetch) {
      get({
        url: 'agendaItems.php',
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          const items: AgendaItem[] = data.map((item: any) => {
            const startDate = new Date(item.startDate);
            const offsetStartDate = new Date(
              startDate.getTime() +
                Math.abs(startDate.getTimezoneOffset() * 60000)
            );
            let offsetEndDate = undefined;
            if (item.endDate) {
              const endDate = new Date(item.endDate);
              offsetEndDate = new Date(
                endDate.getTime() +
                  Math.abs(startDate.getTimezoneOffset() * 60000)
              );
            }
            return {
              id: item.id,
              startTime: item.startTime,
              content: item.content,
              startDate: offsetStartDate,
              endDate: offsetEndDate,
              endTime: item.endTime
            };
          });
          setAgendaItems(items);
          setRefetch(false);
        });
    }
  }, [refetch]);

  function onSelectDate(date: Date): void {
    setSelectedDate(date);
  }

  function addAgendaItem(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    if (content) {
      const newItem: AgendaItem = {
        content: content,
        startDate: selectedDate,
        startTime: time
      };
      const formData = new FormData();
      formData.append('content', newItem.content);
      if (newItem.startDate) {
        formData.append(
          'date_start',
          newItem.startDate.toISOString().split('T')[0]
        );
      }
      formData.append('hour_start', newItem.startTime ?? '');
      post({
        url: 'postAgendaItem.php',
        data: formData,
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status === 'ok') {
            setRefetch(true);
            setTime(undefined);
            setContent('');
          }
        });
    }
  }

  return (
    <div className="agenda-container">
      <Calendar date={selectedDate} onSelectDate={onSelectDate} />
      <div className="section-line"></div>
      <div className="agenda-items">
        {agendaItems &&
          agendaItems
            .filter((item) => compareDates(item.startDate!, selectedDate))
            .map((item) => {
              return (
                <div className="agenda-item">
                  <div className="agenda-desc">
                    <p>
                      {item.startTime === '0:00' || item.startTime === undefined
                        ? 'Todo el día'
                        : item.startTime}{' '}
                      | {item.content}
                    </p>
                  </div>
                  <div
                    className="agenda-icon clickable"
                    onClick={() => navigate('modificar', { state: item })}
                  >
                    <AgendaItemSvg />
                  </div>
                </div>
              );
            })}
      </div>
      <form className="agenda-new-item" onSubmit={addAgendaItem}>
        <input
          aria-label="Time"
          type="time"
          className="agenda-input"
          value={time}
          onChange={(event) => setTime(event.target.value)}
        />
        <input
          required
          type="text"
          className="agenda-input"
          placeholder="Añadir evento día seleccionado"
          style={{ flex: 8 }}
          value={content}
          onChange={(event) => setContent(event.target.value)}
        />
        <button type="submit">
          <AddSvg className="agenda-add-icon" />
        </button>
      </form>
    </div>
  );
}
